import { datadogLogs } from '@datadog/browser-logs';
import { ENVIRONMENT_KEYS } from 'shared/constants';
import { currentEnvironment } from 'shared/services/Environment';
import { sanitizeLogMeta } from 'shared/utils/sanitize-log-meta';

class MonitorService {
  constructor() {
    if (currentEnvironment() === ENVIRONMENT_KEYS.DEVELOPMENT) return;
    datadogLogs.init({
      applicationId: 'f7b46c0a-9450-4b2d-b088-69fd1da47963',
      clientToken: 'pub67d15f7b9cecd75ef58d72757e638ce8',
      site: 'datadoghq.eu',
      service: 'web-application',
      env: currentEnvironment(),
      version: process.env.REACT_APP_RELEASE_VERSION,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      trackingConsent: 'not-granted',
    });
  }

  grantConsent() {
    if (currentEnvironment() === ENVIRONMENT_KEYS.DEVELOPMENT) return;
    datadogLogs.setTrackingConsent('granted');
  }

  info(message, ...args) {
    datadogLogs.logger.info(message, ...args);
  }

  error(message, meta, ...args) {
    datadogLogs.logger.error(message, sanitizeLogMeta(meta), ...args);
  }

  debug(message, ...args) {
    datadogLogs.logger.debug(message, ...args);
  }

  warn(message, meta, ...args) {
    datadogLogs.logger.warn(message, sanitizeLogMeta(meta), ...args);
  }
}

export default new MonitorService();
